import { httpRequest } from "@utils/HttpRequest";
import {
    IPage,
} from "@src/types/FmsTypes";
import { IMdStoreDetail, IMdStoreFields, IMdStoreSearch } from "./StoreTypes";



class StoreService {
    async insert(params: IMdStoreFields) {
        const storeInsertUrl = "/auth/shop/insert";
        let ret = await httpRequest.post<IMdStoreDetail>(storeInsertUrl, params);
        return ret;
    }

    async disable(params: IMdStoreFields) {
        const storeDisableUrl = "/auth/shop/disable";
        let ret = await httpRequest.post<boolean>(storeDisableUrl, params);
        return ret;
    }

    async find(params: IMdStoreFields) {
        const storePageUrl = "/auth/shop/find";
        return await httpRequest.post<IMdStoreDetail[]>(storePageUrl, params);
    }

    /**
     * 获取门店选择项
     * @param params 
     * @returns 
     */
    async storeDs(params: IMdStoreFields) {
        let { retData } = await this.find(params);
        return retData.map(el => {
            let label = ""
            if (el.name) {
                label = `${el.name}-${el.branch}`
            }
            return {
                label: label,
                value: el.code ?? ""
            }
        })
    }

    /**
     * 分页加载店铺信息
     * @param params 
     * @returns 
     */
    async page(params: IMdStoreSearch) {
        const storePageUrl = "/auth/shop/page";
        return await httpRequest.post<IPage<IMdStoreDetail>>(storePageUrl, params);
    }

    /**
     * 分页加载店铺信息-新
     * @param params 
     * @returns 
     */
    async finPage(params: IMdStoreSearch) {
        const storePageUrl = "/auth/shop/findpage";
        return await httpRequest.post<IPage<IMdStoreDetail>>(storePageUrl, params);
    }

    async one(params: IMdStoreFields) {
        const storeDisableUrl = "/auth/shop/one";
        return await httpRequest.post<IMdStoreDetail>(storeDisableUrl, params);
    }

    /**
     * 同步店铺信息
     * @param params 
     * @returns 
     */
    async sync(params: IMdStoreFields) {
        const storePageUrl = "/auth/shop/sync";
        params.branchList = ["main", "portal"];
        return await httpRequest.post<boolean>(storePageUrl, params, {
            timeout: 15000
        });
    }

    async syncPage(params: IMdStoreSearch) {
        const storePageUrl = "/auth/shop/syncPage";
        params.branchList = ["main", "portal"];
        return await httpRequest.post<boolean>(storePageUrl, params);
    }

    async syncOne(params: IMdStoreFields) {
        const storePageUrl = "/auth/shop/syncPage";

        return await httpRequest.post<boolean>(storePageUrl, params);
    }
}

export const storeService = new StoreService();
export default storeService
